import { useCallback, useState } from "react";
import { GRAPHICS } from "../data/content";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { Lightbox } from "./Lightbox";

const OFFSETS = ["", "mt-8 lg:mt-16", "mt-4 lg:mt-8", "mt-12 lg:mt-24", "mt-6 lg:mt-12", "mt-14 lg:mt-28", "mt-2 lg:mt-4", "mt-10 lg:mt-20"];

const Poster = ({ item, className = "", delay = 0, onOpen }) => (
    <Reveal className={className} delay={delay}>
        <figure
            className="group cursor-pointer"
            data-cursor="VIEW"
            data-testid={`graphic-item-${item.id.replace(".", "").toLowerCase()}`}
            onClick={() => onOpen(item)}
        >
            <div className="overflow-hidden bg-[#101010]">
                <img src={item.src} alt={item.alt} loading="lazy" decoding="async" className="poster-img w-full h-auto" />
            </div>
            <figcaption className="mt-4 flex items-baseline justify-between gap-4">
                <div className="flex items-baseline gap-3 min-w-0">
                    <span className="font-mono2 text-[10px] text-[var(--red)]">{item.id}</span>
                    <span className="font-display text-[11px] md:text-sm uppercase tracking-tight leading-tight">{item.title}</span>
                </div>
                <span className="font-mono2 text-[9px] tracking-[0.15em] text-[var(--mute)] uppercase whitespace-nowrap hidden sm:inline">
                    {item.meta}
                </span>
            </figcaption>
        </figure>
    </Reveal>
);

export const GraphicWork = () => {
    const [active, setActive] = useState(null);
    const close = useCallback(() => setActive(null), [setActive]);

    return (
        <section className="pt-28 md:pt-44" data-testid="graphic-section">
            <SectionHeading index="01" title="Graphic works" id="work" />
            <div className="px-6 md:px-12 grid grid-cols-2 lg:grid-cols-4 gap-x-4 md:gap-x-8 gap-y-12 md:gap-y-20 items-start">
                {GRAPHICS.map((g, i) => (
                    <Poster key={g.id} item={g} delay={(i % 4) * 0.08} className={OFFSETS[i % 8]} onOpen={setActive} />
                ))}
            </div>
            <Lightbox item={active} onClose={close} />
        </section>
    );
};
